"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require("../../module");

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresOmalomaPayMethodPickerController = function () {
  function WinresOmalomaPayMethodPickerController($scope) {
    _classCallCheck(this, WinresOmalomaPayMethodPickerController);

    this.$scope = $scope;

    this.$scope.methods = [];
    this.$scope.selected = null;

    this.$scope.bgImagePaytraylVerkkoPankki = "https://omalomat.fi/wp-content/uploads/2018/04/maksutavat-paytrail-verkkopankki.png";
    this.$scope.bgImagePaytraylLuottokortit = "https://omalomat.fi/wp-content/uploads/2018/04/maksutavat-paytrail-luottokortit.png";
  }

  _createClass(WinresOmalomaPayMethodPickerController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this.$scope.$watch(function () {
        return _this.methods;
      }, function (methods) {
        return _this.update(methods);
      });
    }
  }, {
    key: "update",
    value: function update(methods) {
      this.$scope.methods = methods || [];
      if (this.$scope.selected === null && this.$scope.methods.length > 0) {
        this.select(0);
      }
    }
  }, {
    key: "select",
    value: function select(index) {
      this.$scope.selected = index;
      this.onChange({ method: this.methods[index] });
    }
  }]);

  return WinresOmalomaPayMethodPickerController;
}();

WinresOmalomaPayMethodPickerController.$inject = ['$scope'];

_module3.default.component('winresOmalomaPayMethodPicker', {
  template: require('./winresOmalomaPayMethodPicker.html'),
  controller: WinresOmalomaPayMethodPickerController,
  bindings: {
    methods: '<',
    onChange: '&'
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaPayMethodPicker/winresOmalomaPayMethodPicker.js
// module id = 353
// module chunks = 2